var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Suspense } from 'react';
import LLModal from './Modal.Lazy';
/**
 * Wraps lazy-loaded Modal component in a Suspense handler. Only uses lazy component
 * when modal is open.
 * Modal.Lazy can be imported directly if used inside higher level Suspense wrapper.
 */
var WrappedLLModal = function (props) { return (React.createElement(Suspense, { fallback: "" }, props.isOpen && React.createElement(LLModal, __assign({}, props)))); };
export default WrappedLLModal;
